<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="active" *ngIf="isBulkEdit; else bulkDuplicate">
          {{ selectedItems.length }}
          {{ entityType.split("_").join(" ") }}(s) selected
        </span>
        <ng-template #bulkDuplicate>
          <span class="active">
            Selected {{ entityType.split("_").join(" ") }}:
            <ng-container
              *ngIf="dspType == 'tdsp' && (step == 'updateTdspIoFlights' || step == 'updateTdspLiFlights')"
            >
              {{ selectedItems[0].name }} - ({{ selectedItems[0].id }})
            </ng-container>
          </span>
        </ng-template>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="scroll">
      <table class="selected-item-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> S.No</span>
          </th>
          <td mat-cell *matCellDef="let row; let index = index">
            <span class="table_value_name"> {{ index + 1 }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> ID</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name"> {{ row.id }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Name</span>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [title]="row.name.length > 30 ? row.name : ''"
            [ngClass]="{ cursor_pointer: row.name.length > 30 }"
          >
            <span class="table_value_name">
              {{
                row.name.length > 30
                  ? row.name.substring(0, 30) + "..."
                  : (row.name | titlecase)
              }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="budget.type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Budget Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row.budget.type | titlecase }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="budget_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Budget Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row.budget_type | titlecase }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="flights">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Flights </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="scrollable-content table_value_name">
              <b>Total flights</b>: {{ row.flights.length }}
              <ol class="active-flight-list">
                <li class="flight" *ngFor="let flight of row.flights">
                <ng-container *ngIf="entityType === 'line_item'; else ioFlight">
                  {{ flight.flight?.start_date | date }} to
                  {{ flight.flight?.end_date | date }}
                </ng-container>

                <ng-template #ioFlight>
                  {{ flight.start_date | date }} to
                  {{ flight.end_date | date }}
                </ng-template>


                  <b class="ms-2">Budget: </b
                  >
                   <ng-container *ngIf="entityType === 'line_item'; else ioBudget">
                    {{ flight.budget | currency: clientCurrency : 'symbol' : '1.2-2' }}
                   </ng-container>

                   <ng-template #ioBudget>
                    {{
                      row.budget_type == "revenue"
                        ? (flight.revenue_budget | currency: clientCurrency : "symbol" : "1.2-2")
                        : flight.imps_budget + " " +"imps"
                    }}
                  </ng-template>
                  <ng-container *ngIf="entityType=='line_item'">
                    <b class="ms-2">Daily Budget: </b>
                    <ng-container>
                      {{ flight.daily_budget | currency: clientCurrency : 'symbol' : '1.2-2' }}
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="row.pacing == 'pace_daily'">
                    <b class="ms-2">Daily Budget: </b
                    >{{
                      row.budget_type == "revenue"
                        ? (flight.daily_revenue_budget
                          | currency : clientCurrency : "symbol" : "1.2-2")
                        : flight.daily_imps_budget + " " + "imps"
                    }}
                  </ng-container>
                  <ng-container *ngIf="entityType !== 'line_item'">
                    <b class="ms-2">Reference No: </b
                    >{{ flight.description ? flight.description : "NA" }}
                  </ng-container>
                  <ng-container *ngIf="row.enable_click_pacing">
                    <b class="ms-2">Daily Minimum Clicks: </b
                    >{{ flight.click_pacing_daily_minimum_budget }}
                    <b class="ms-2">Total Flight Clicks: </b
                    >{{ flight.click_pacing_flight_budget }}
                    <b class="ms-2">Average Clicks: </b
                    >{{ flight.click_pacing_average_daily_budget }}
                    <b class="ms-2">Clicks Served: </b
                    >{{ flight.click_pacing_clicks_delivered }}
                  </ng-container>
                </li>
              </ol>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name">Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name"> {{ row.type | titlecase }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="io_deal_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name">IO Deal Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ ioDealTypeMapping[row.io_deal_type] }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="pixels">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name">Pixels & Trackers</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.pixel_mappings.length > 0 || row.image_pixels.length > 0;
                else noValue
              "
            >
              <span class="table_value_name">
                <ul *ngFor="let pixel of row.pixel_mappings">
                  <li>
                    {{ pixel.mapping.name }} ({{ pixel.mapping.id }})
                    <b>Event Type: </b
                    >{{
                      pixel.mapping.data_event_type.split("_").join(" ")
                        | titlecase
                    }}
                  </li>
                </ul>
                <ul *ngFor="let img_pixel of row.image_pixels">
                  <li>
                    {{ img_pixel.image_pixel.name }} ({{
                      img_pixel.image_pixel.id
                    }})
                  </li>
                </ul>
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No association with universal pixels & conversion pixels.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="budget_intervals">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Budget Flights </span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column-flight">
            <div class="scrollable-content table_value_name">
              <b>Total flights</b>: {{ row.budget_intervals.length }}
              <ol class="active-flight-list">
                <li class="flight" *ngFor="let flight of row.budget_intervals">
                  {{ flight.start_date.split(" ") | date }} to
                  {{ flight.end_date.split(" ") | date }} for
                  {{
                    row.budget_type == "revenue"
                      ? (flight.revenue_budget
                        | currency: clientCurrency : "symbol" : "1.2-2")
                      : flight.imps_budget + " " + "imps"
                  }}
                </li>
              </ol>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name">
              Start Date ({{ clientTimeZone }})</span
            >
          </th>
          <td mat-cell *matCellDef="let row">
            <span [ngClass]="{ table_value_name: true, red: row.is_started }">
              {{ row.start_date.split(" ") | date }}
              <ng-container *ngIf="row.is_started">
                (Date in past)
              </ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name">
              End Date ({{ clientTimeZone }})</span
            >
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row.end_date.split(" ") | date }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="min_cpm">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Min CPM</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row?.min_cpm }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="max_cpm">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Max CPM</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row?.max_cpm }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="applicable_kpis">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Applicable KPIs</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ getApplicableKPIs(row.insertion_order) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="budget.total_budget">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Total Budget</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
                *ngIf="isValidNumber(row.budget.total_budget); else noValue"
              >
                {{
                  row.budget.total_budget
                    | currency : clientCurrency : "symbol" : "1.2-2"
                }}
              </ng-container>
              <ng-template #noValue>-</ng-template>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="use_fallback">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Use Fallback</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row?.use_fallback ? row.use_fallback : "N/A" }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="budget.lifetime">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Total Budget</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
                *ngIf="isValidNumber(row.budget?.lifetime); else noValue"
              >
                {{
                  row.budget?.lifetime
                    | currency : clientCurrency : "symbol" : "1.2-2"
                }}
              </ng-container>
              <ng-template #noValue>-</ng-template>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="budget.daily">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Daily Budget </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
                *ngIf="isValidNumber(row.budget?.daily); else noValue"
              >
                {{
                  row.budget?.daily
                    | currency : clientCurrency : "symbol" : "1.2-2"
                }}
              </ng-container>
              <ng-template #noValue>-</ng-template>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="active_flights">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Active Flights </span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column-flight">
            <div class="scrollable-content table_value_name">
              <b>Total flights</b>:
              {{ row.active_flights ? row.active_flights.length : "N/A" }}
              <ol class="active-flight-list">
                <li class="flight" *ngFor="let flight of row?.active_flights">
                  {{ flight.start_date.split(" ") | date }} to
                  {{ flight.end_date.split(" ") | date }} for
                  {{
                    flight.budget
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </li>
              </ol>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bidding.stratergy">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Bidding </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="table_value_name">
              <p>
                <b>Bid Strategy</b>:
                {{ biddingStratergy[row.bidding.strategy] }}
              </p>

              <ng-container *ngIf="row.bidding.strategy === 'cpm_paced'">
                <p>
                  <b>CPM Bid</b>:
                  {{
                    row.bidding.values.cpm_bid
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </p>
              </ng-container>

              <ng-container *ngIf="row.bidding.strategy === 'flat_cpm'">
                <p>
                  <b>CPM Bid</b>:
                  {{
                    row.bidding.values.cpm_bid
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </p>
              </ng-container>

              <ng-container *ngIf="row.bidding.strategy === 'cpa_paced'">
                <p><b>CPA Event</b>>: {{ row.bidding.values.cpa_event }}</p>
                <p><b>CPA Target</b>: {{ row.bidding.values.cpa_target }}</p>
                <p>
                  <b>Max Bid</b>:
                  {{
                    row.bidding.values.max_bid
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </p>
              </ng-container>

              <ng-container *ngIf="row.bidding.strategy === 'cpc_paced'">
                <p>
                  <b>Max Bid</b>:
                  {{
                    row.bidding.values.max_bid
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </p>
                <p>
                  <b>eCPC Target</b>:
                  {{
                    row.bidding.values.ecpc_target
                      | currency : clientCurrency : "symbol" : "1.2-2"
                  }}
                </p>
              </ng-container>

              <p><b>Multiplier</b>: {{ row.bidding.multiplier }}</p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="frequency">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Frequency Cap</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row?.frequency_caps; else noCap">
              <div
                *ngFor="let freq of row.frequency_caps"
                class="table_value_name"
              >
                <b>{{ freq.imps }}</b> impressions per
                <b>{{ freq.duration }}</b>
                <b>{{ freq.interval }}</b>
              </div>
            </ng-container>
            <ng-template #noCap> N/A </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="events">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Events</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.events.length > 0; else noValue">
              <b>Associated Events</b>: {{ row.events.length }}
              <mat-chip-listbox>
                <mat-chip-option *ngFor="let event of row.events">
                  {{ event.name }} ({{ event.id }})
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No association with events.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="creatives">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Creatives</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.creatives.length > 0; else noValue">
              <b>Associated Creatives</b>: {{ row.creatives.length }}
              <mat-chip-listbox>
                <mat-chip-option *ngFor="let crtv of row.creatives">
                  {{ crtv.name }} ({{ crtv.id }})
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No association with creatives.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="crtv_meta">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Creatives</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.crtv_meta.length > 0; else noValue">
              <b>Associated Creatives</b>: {{ row.crtv_meta.length }}
              <mat-chip-listbox>
                <mat-chip-option *ngFor="let crtv of row.crtv_meta">
                  {{ crtv.name }} ({{ crtv.id }})
                </mat-chip-option>
              </mat-chip-listbox>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No association with creatives.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.country">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Country</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.geo.country.length > 0; else noValue"
              >
                <b>Total targets</b>: {{ row.targeting.geo.country.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let country of row.targeting.geo.country"
                  >
                    {{ country.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific countries were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.region">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Region</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.geo.region.length > 0; else noValue"
              >
                <b>Total targets</b>: {{ row.targeting.geo.region.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let region of row.targeting.geo.region"
                  >
                    {{ region.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific regions were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.city">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> City</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.geo.city.length > 0; else noValue"
              >
                <b>Total targets</b>: {{ row.targeting.geo.city.length }}
                <mat-chip-listbox>
                  <mat-chip-option *ngFor="let city of row.targeting.geo.city">
                    {{ city.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific cities were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.zip">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Zip Code</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.geo.zip.length > 0; else noValue"
              >
                <b>Total targets</b>: {{ row.targeting.geo.zip.length }}
                <mat-chip-listbox>
                  <mat-chip-option *ngFor="let zip of row.targeting.geo.zip">
                    {{ zip }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific zip codes were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.platform.device_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Device Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              {{ row.targeting.platform.device_type.join(",") }}
            </span>
          </td>
        </ng-container>

          <ng-container matColumnDef="targeting.device_types">
            <th mat-header-cell *matHeaderCellDef>
              <span class="table_header_name"> Device Types</span>
            </th>
            <td mat-cell *matCellDef="let row">
              <span *ngFor="let device of row.targeting.device_types" class="table_value_name">
                 {{device.type | titlecase}} - <b>{{device.bid_factor}}</b><br>
              </span>
            </td>
          </ng-container>
        
        <ng-container matColumnDef="targeting.environment.environment_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Inventory Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
                *ngFor="
                  let env of row.targeting.environment.environment_type;
                  let l = last
                "
              >
                {{ env.split("_").join(" ") | titlecase }}
                <ng-container *ngIf="!l">,</ng-container>
              </ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.inventory_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Inventory Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
                *ngFor="
                  let env of row.targeting.inventory_type;
                  let l = last
                "
              >
                {{ env.split("_").join(" ") | titlecase }}
                <ng-container *ngIf="!l">,</ng-container>
              </ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.inventory_types">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Inventory Type</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
              >
                {{ row.targeting.inventory_types }}
              </ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.premium_inventory">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Premium Inventory</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="table_value_name">
              <ng-container
              >
                {{ row.targeting.premium_inventory }}
              </ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.app_site.domains">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Domain</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.app_site.domains.length > 0; else noValue"
              >
                <b>Total targets</b>:
                {{ row.targeting.app_site.domains.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let domain of row.targeting.app_site.domains"
                  >
                    {{ domain.name }} ({{ domain.id }})
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific domains were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.content.content_category">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Content Category</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.content.content_category.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.content.content_category.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="
                      let cnt_ctg of row.targeting.content.content_category
                    "
                  >
                    {{ cnt_ctg.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific Content Categories were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.app_site.app_bundle">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> App Bundle</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.app_site.app_bundle.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.app_site.app_bundle.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let app_bundle of row.targeting.app_site.app_bundle"
                  >
                    {{ app_bundle.name }} ({{ app_bundle.id }})
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific App bundles were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.environment.ads_txt">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Ads Txt</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.environment.ads_txt.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.environment.ads_txt.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let ads_txt of row.targeting.environment.ads_txt"
                  >
                    {{ ads_txt.name }} ({{ ads_txt.id }})
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific Ads txt were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.environment.native_layout">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Native Layout </span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.environment.native_layout.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.environment.native_layout.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="
                      let native_layout of row.targeting.environment
                        .native_layout
                    "
                  >
                    {{ native_layout.name }} ({{ native_layout.id }})
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific native layouts were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.platform.operating_system">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> OS</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.platform.operating_system.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.platform.operating_system.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let os of row.targeting.platform.operating_system"
                  >
                    {{ os.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific OS were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.user.segment">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Segments</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.user.segment.length > 0; else noValue"
              >
                <b>Total targets</b>: {{ row.targeting.user.segment.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let segment of row.targeting.user.segment"
                  >
                    {{ segment.name }} ({{ segment.id }})
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">No specific segments were targeted.</p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.time.user_time_of_week">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Day Part</span>
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <table class="table_value_name">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Selected Hours</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let day of daysOfWeekOrder">
                  <tr *ngIf="selectedHours[i][day].length > 0">
                    <td>{{ day | titlecase }}</td>
                    <td>{{ selectedHours[i][day].join(", ") }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.user_time_of_week">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Day Part</span>
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <table class="table_value_name">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Selected Hours</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let day of daysOfWeekOrder">
                  <tr *ngIf="selectedHours[i][day].length > 0">
                    <td>{{ day | titlecase }}</td>
                    <td>{{ selectedHours[i][day].join(", ") }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.audio.audio_start_delay">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Start Delay</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.audio.audio_start_delay.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.audio.audio_start_delay.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let audio of row.targeting.audio.audio_start_delay"
                  >
                    {{ audio.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific start delay were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.video.start_delay">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Start Delay</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.video.start_delay.length > 0; else noValue"
              >
                <b>Total targets</b>:
                {{ row.targeting.video.start_delay.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let start_delay of row.targeting.video.start_delay"
                  >
                    {{ start_delay.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific start delay were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.video.playback_method">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Playback Method</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.video.playback_method.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.video.playback_method.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="
                      let playback_method of row.targeting.video.playback_method
                    "
                  >
                    {{ playback_method.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific playback method were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="targeting.video.video_placement_type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Placement Type</span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="
                  row.targeting.video.video_placement_type.length > 0;
                  else noValue
                "
              >
                <b>Total targets</b>:
                {{ row.targeting.video.video_placement_type.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="
                      let video_placement_type of row.targeting.video
                        .video_placement_type
                    "
                  >
                    {{ video_placement_type.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific video placement were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="targeting.video.player_size">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Player Size </span>
          </th>
          <td mat-cell *matCellDef="let row" class="scrollable-column">
            <div class="scrollable-content label-container">
              <ng-container
                *ngIf="row.targeting.video.player_size.length > 0; else noValue"
              >
                <b>Total targets</b>:
                {{ row.targeting.video.player_size.length }}
                <mat-chip-listbox>
                  <mat-chip-option
                    *ngFor="let player_size of row.targeting.video.player_size"
                  >
                    {{ player_size.name }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </ng-container>
              <ng-template #noValue>
                <p class="trgt-assc-msg">
                  No specific player size were targeted.
                </p>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bidding.pacing">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Pacing </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <span
              [ngClass]="{
                table_value_name: true,
                red:
                  row.bidding?.pacing != 'daily_ahead' &&
                  row.bidding?.pacing != 'daily_even'
              }"
            >
              {{
                row.bidding?.pacing
                  ? (row.bidding.pacing?.split("_").join(" ") | titlecase)
                  : "N/A"
              }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.country_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Country Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting?.geo?.country.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting?.geo?.country_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting?.geo?.country_action === 'include',
                  'exclude-icon-selected':
                    row.targeting?.geo?.country_action === 'exclude'
                }"
              >
                {{
                  row.targeting?.geo?.country_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific countries were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.region_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Region Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting?.geo?.region.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting?.geo?.region_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting?.geo?.region_action === 'include',
                  'exclude-icon-selected':
                    row.targeting?.geo?.region_action === 'exclude'
                }"
              >
                {{
                  row.targeting?.geo?.region_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific regions were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.city_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> City Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting?.geo?.city.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting?.geo?.city_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting?.geo?.city_action === 'include',
                  'exclude-icon-selected':
                    row.targeting?.geo?.city_action === 'exclude'
                }"
              >
                {{
                  row.targeting?.geo?.city_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific cities were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.geo.zip_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Zip Code Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting?.geo?.zip.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting?.geo?.zip_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting?.geo?.zip_action === 'include',
                  'exclude-icon-selected':
                    row.targeting?.geo?.zip_action === 'exclude'
                }"
              >
                {{
                  row.targeting?.geo?.zip_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific zip codes were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.environment.ads_txt_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Ads Txt Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting.environment.ads_txt.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting.environment.ads_txt_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.environment.ads_txt_action === 'include',
                  'exclude-icon-selected':
                    row.targeting.environment.ads_txt_action === 'exclude'
                }"
              >
                {{
                  row.targeting.environment.ads_txt_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific ads txt were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.environment.native_layout_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Native Layout Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.environment.native_layout.length > 0;
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.environment.native_layout_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.environment.native_layout_action ===
                    'include',
                  'exclude-icon-selected':
                    row.targeting.environment.native_layout_action === 'exclude'
                }"
              >
                {{
                  row.targeting.environment.native_layout_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific ads txt were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.user.user_id_present">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> User ID </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.user.user_id_present == 'include' ||
                  row.targeting.user.user_id_present == 'exclude';
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.user.user_id_present === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.user.user_id_present === 'include',
                  'exclude-icon-selected':
                    row.targeting.user.user_id_present === 'exclude'
                }"
              >
                {{
                  row.targeting.user.user_id_present === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">User ID were not targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.platform.operating_system_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> OS Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.platform.operating_system.length > 0;
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.platform.operating_system_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.platform.operating_system_action ===
                    'include',
                  'exclude-icon-selected':
                    row.targeting.platform.operating_system_action === 'exclude'
                }"
              >
                {{
                  row.targeting.platform.operating_system_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">No specific os were targeted.</p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.audio.audio_start_delay_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Start delay Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.audio.audio_start_delay.length > 0;
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.audio.audio_start_delay_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.audio.audio_start_delay_action === 'include',
                  'exclude-icon-selected':
                    row.targeting.audio.audio_start_delay_action === 'exclude'
                }"
              >
                {{
                  row.targeting.audio.audio_start_delay_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No specific Start delay were targeted.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.video.start_delay_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Start Delay Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting.video.start_delay.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting.video.start_delay_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.video.start_delay_action === 'include',
                  'exclude-icon-selected':
                    row.targeting.video.start_delay_action === 'exclude'
                }"
              >
                {{
                  row.targeting.video.start_delay_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No specific start delay were targeted.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.video.playback_method_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Playback Method Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.video.playback_method.length > 0;
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.video.playback_method_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.video.playback_method_action === 'include',
                  'exclude-icon-selected':
                    row.targeting.video.playback_method_action === 'exclude'
                }"
              >
                {{
                  row.targeting.video.playback_method_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No specific playback method were targeted.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container
          matColumnDef="targeting.video.video_placement_type_action"
        >
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Placement Type Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.targeting.video.video_placement_type.length > 0;
                else noValue
              "
            >
              <span
                [matTooltip]="
                  row.targeting.video.video_placement_type_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.video.video_placement_type_action ===
                    'include',
                  'exclude-icon-selected':
                    row.targeting.video.video_placement_type_action ===
                    'exclude'
                }"
              >
                {{
                  row.targeting.video.video_placement_type_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No specific placement type were targeted.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="targeting.video.player_size_action">
          <th mat-header-cell *matHeaderCellDef>
            <span class="table_header_name"> Player Size Action </span>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.targeting.video.player_size.length > 0; else noValue"
            >
              <span
                [matTooltip]="
                  row.targeting.video.player_size_action === 'include'
                    ? 'Included'
                    : 'Excluded'
                "
                [ngClass]="{
                  'material-icons': true,
                  'include-icon-selected':
                    row.targeting.video.player_size_action === 'include',
                  'exclude-icon-selected':
                    row.targeting.video.player_size_action === 'exclude'
                }"
              >
                {{
                  row.targeting.video.player_size_action === "include"
                    ? "check"
                    : "block"
                }}
              </span>
            </ng-container>
            <ng-template #noValue>
              <p class="trgt-assc-msg">
                No specific player size were targeted.
              </p>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="selectedItemColumn"></tr>
        <tr mat-row *matRowDef="let row; columns: selectedItemColumn"></tr>
        <mat-paginator
          #paginator
          [pageSizeOptions]="[10, 15, 25, 100]"
          [length]="selectedItems.length"
        >
        </mat-paginator>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-container
  *ngIf="
    step != 'all' &&
    step != 'updateTdspIoFlights' &&
    step != 'updateTdspPixelsAndTags' &&
    step != 'updateTdspLiFlights'
  "
>
  <div class="warning_message mt-3 mb-2">
    <ul class="unset-margin">
      <li>
        Changes made will be applied to all the selected
        {{ entityType.split("_").join(" ") }}(s).
      </li>
      <li
        *ngIf="
          selectedFields.includes('start_date') &&
          !selectedFields.includes('end_date') &&
          step == 'basic'
        "
      >
        The start date must be on or before
        {{ minEndDate | date : "MMM d, y" }}, as it is the earliest end date of
        one of the {{ entityType.split("_").join(" ") }}(s).
      </li>
      <li
        *ngIf="
          !selectedFields.includes('start_date') &&
          selectedFields.includes('end_date') &&
          step == 'basic'
        "
      >
        The end Date should be on or after
        {{ maxStartDate | date : "MMM d, y" }}, as it is the latest start date 
        of one of the {{ entityType.split("_").join(" ") }}(s).
      </li>
    </ul>
  </div>
</ng-container>
